import { IMapsService } from './IMapsService';
import { AzureMapsService } from './AzureMapsService';

const mapsService: IMapsService = new AzureMapsService();
export default mapsService;
// TODO: use conditional logic to set this based on MapsProvider value from config